module.exports = __webpack_public_path__ + "static/media/icon-graph-2.f94ccc07.svg";